<template>
	<div v-parallax-fit="parallax" ref="family06" class="slide-polaroid">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/03_family06.png">
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/henry/1.srt',
				'es': '/themes/rise-theme/resources/assets/audio/henry/1_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 0,
					end: 400,
					fromStyle: { transform: 'translateX(0%) translateY(0%) scale(0) rotate(0deg)' },
					toStyle: { transform: 'translateX(20%) translateY(-40%) scale(1.7) rotate(-15deg)' },
					easing: 'linear'
				},
				{
					start: 400,
					end: 800,
					fromStyle: { transform: 'translateX(20%) translateY(-40%) scale(1.7) rotate(-15deg)' },
					toStyle: { transform: 'translateX(-15%) translateY(-170%) scale(1.7) rotate(-15deg)' },
					easing: 'linear'
				},
				{
					start: 800,
					end: 1200,
					fromStyle: { transform: 'translateX(-15%) translateY(-170%) scale(1.7) rotate(-15deg)' },
					toStyle: { transform: 'translateX(0%) translateY(-270%) scale(1.7) rotate(5deg)' },
					easing: 'linear'
				},
				{
					start: 1200,
					end: 1600,
					fromStyle: { transform: 'translateX(0%) translateY(-270%) scale(1.7) rotate(5deg)' },
					toStyle: { transform: 'translateX(70%) translateY(-290%) scale(1.7) rotate(-15deg)' },
					easing: 'linear'
				},
				{
					start: 1600,
					end: 2000,
					fromStyle: { transform: 'translateX(70%) translateY(-290%) scale(1.7) rotate(-15deg)' },
					toStyle: { transform: 'translateX(200%) translateY(-320%) scale(1.7) rotate(4deg)' },
					easing: 'linear'
				},
				{
					start: 3200,
					end: 3600,
					fromStyle: { transform: 'translateX(200%) translateY(-320%) scale(1.7) rotate(4deg)' },
					toStyle: { transform: 'translateX(120%) translateY(-320%) scale(1) rotate(20deg)' },
					easing: 'linear'
				},
				{
					start: 3600,
					end: 4100,
					fromStyle: { transform: 'translateX(120%) translateY(-320%) scale(1) rotate(20deg)' },
					toStyle: { transform: 'translateX(-230%) translateY(-200%) scale(1) rotate(-25deg)' },
					easing: 'linear'
				},
				{
					start: 4100,
					end: 5000,
					fromStyle: { transform: 'translateX(-230%) translateY(-200%) scale(1) rotate(-25deg)' },
					toStyle: { transform: 'translateX(-1000%) translateY(-200%) scale(1) rotate(-25deg)' },
					easing: 'linear'
				}
			]
		}
	},
	created() {
		this.$watch('store.lang', newVal => {
			if (Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/henry/1.mp3';
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/henry/evidence/1.jpg',
					url: 'https://history.coateslibrary.com/exhibits/show/exhibit/community/involvement/redlining',
					link_title: {
						'en': "Redlining: the Racist Policy that Shaped San Antonio's Urban Core",
						'es': 'Redlining: la política racista que dio forma al núcleo urbano de San Antonio'
					},
				}
			],
			text: {
				'en': '"The HOLC categorized neighborhoods with high populations of African American and Latino residents as “definitely declining” or “hazardous.” It then used these labels to deny home loans to people living in these communities. This policy intensified existing racial segregation and conditions of poverty as they prevented people of color from building wealth through homeownership..."',
				'es': '"El HOLC clasificó los vecindarios con una alta población de residentes afroamericanos y latinos como "definitivamente en declive" o "peligrosos". Luego usó estas etiquetas para negar préstamos hipotecarios a las personas que viven en estas comunidades. Esta política intensificó la segregación racial existente y las condiciones de pobreza, ya que impedían que las personas de color acumularan riqueza a través de la propiedad de vivienda..."'
			}
		};
		const text = {
			'en': "For many people of color in most American cities, buying a home of their own was a struggle due to the country's racist housing policies. Mortgages to Black families were often restricted, so just as Ronald's grandmother experienced, many had to find alternative financing and their homes were often segregated.",
			'es': 'Para muchas personas de color en la mayoría de las ciudades estadounidenses, comprar una casa propia fue una lucha debido a las políticas de vivienda racistas del país. Las hipotecas para las familias negras a menudo estaban restringidas, por lo que, tal como lo experimentó la abuela de Ronald, muchos tuvieron que encontrar financiamiento alternativo y sus hogares a menudo estaban segregados.'
		};

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateX(0%) translateY(0%) scale(0) rotate(0deg)') {
					self.$evidence.value = JSON.stringify(evidence);
					self.$readMore.value = text;
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
				}
			});
		});

		this.mutationObserver.observe(this.$refs.family06, {
			attributes: true,
			attributeFilter: ['style']
		});

	},
	unmounted() {
		this.mutationObserver.disconnect();
	},
}
</script>

<style lang="scss" scoped>
.slide-polaroid {
	max-width: 130px;
	position: absolute;
	left: 19%;
	bottom: 14%;
	z-index: 2;
	transition: all 0.1s linear;
}

@media screen and (max-width: 1680px) {
	.slide-polaroid {
		max-width: 110px;
		position: absolute;
		left: 22%;
		bottom: 8%;
	}
}

@media screen and (max-width: 1280px) {
	.slide-polaroid {
		max-width: 63px;
		left: 20%;
		bottom: 18%;
	}
}

@media screen and (max-width: 650px) {
	.slide-polaroid {
		max-width: 35px;
		left: 20%;
		bottom: 15%;
	}
}
</style>
